<script>
  import { afterUpdate, onMount } from 'svelte'
  import { getReturnDate, puzzlePack } from '../models/puzzlePack.js'
  import { slide } from 'svelte/transition'
  import Popup from '../components/Popup.svelte'

  export let showDate = false

  let current
  let puzzles = {}
  $: maxPuzzles = 0 ? !$puzzlePack.isInit() : parseInt($puzzlePack.maxPuzzles)

  onMount(() => {
    puzzlePack.clearError()
  })

  afterUpdate(() => {
    current = parseInt($puzzlePack.itemCount)

    for (const x of Array(maxPuzzles).keys()) {
      let idx = x + 1
      puzzles[idx] = false
      if (idx <= current) {
        puzzles[idx] = true
      }
    }
  })
</script>

<style type="text/less">
  .quota {
    background: var(--col-gray-98);
    border: solid 1px var(--col-gray-90);
    border-radius: var(--border-radius);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .quota-descr {
    padding: var(--spacing-xs) var(--spacing-sm);

    h4 {
      margin: 0;
    }

    span {
      display: block;
      font-size: 0.9em;
      line-height: var(--line-height);
    }
  }

  .quota-meter {
    text-align: center;
    padding: var(--spacing-sm);
    padding-left: 0.88rem;
    white-space: nowrap;

    .piece {
      font-size: 2rem;
      position: relative;
      left: 0.11em;
      margin-left: -0.22em;
      stroke: var(--col-gray-98);
      stroke-width: 0.5em;
      fill: var(--col-gray-80);

      &.fill {
        fill: var(--col-accent-1);
      }
    }
  }

  @media (max-width: 600px) {
    .quota {
      flex-direction: column;
    }
  }
</style>

{#await $puzzlePack}
  <span>Loading puzzle pack details</span>
{:then}
  {#if puzzlePack && $puzzlePack.errorMsg}
    <Popup message={$puzzlePack.errorMsg} close={puzzlePack.clearError} />
  {/if}
  {#if $puzzlePack.initialized}
    <div class="quota">
      <div class="quota-descr">
        <h4>Your Puzzle Pack</h4>
        {#if maxPuzzles - current !== 0}
          <span>{current} out of {maxPuzzles} puzzles chosen</span>
        {:else}
          <span>
            You maxed out your quota!
            <a href="/cart">Checkout now!</a>
          </span>
        {/if}

        {#if showDate}
          <span class="return-date">{getReturnDate()}</span>
        {/if}
      </div>

      <div class="quota-meter">
        {#each Object.keys(puzzles) as piece}
          <svg class="icon piece" class:fill={puzzles[piece] === true}>
            <use href="/icons.svg#puzzle-piece" />
          </svg>
        {/each}
      </div>
    </div>
  {/if}
{/await}
